import * as z from 'zod';

export const eventSchema = z.object({
  id: z.string(),
  objectId: z.string().uuid().nullable(),
  coords: z
    .object({
      type: z.string(),
      coordinates: z.array(z.number())
    })
    .optional(),
  title: z.string(),
  subtitle: z.string().nullable(),
  eventNumber: z.number().int().nullable(),
  locationName: z.string().nullable(),
  dateInfo: z.string().nullable(),
  isActive: z.boolean(),
  isApproved: z.boolean().nullable(),
  clientName: z.string().nullable(),
  categoryName: z.string().nullable(),
  urlKey: z.string().nullable(),
  clientKey: z.string().nullable(),
  culture: z.string().nullable(),
  dateInfoList: z.array(z.string()).nullable(),
  soldOut: z.boolean(),
  isSticky: z.boolean(),
  isAssigned: z.boolean(),
  sessionCount: z.number().int().nullable(),
  dateDisplay: z
    .object({
      months: z.string(),
      dates: z.string(),
      days: z.string(),
      times: z.string(),
      isOngoing: z.boolean()
    })
    .nullable(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  mapUrl: z.string().url().nullable(),
  promoImageUrl: z.string().url().nullable(),
  appImageUrl: z.string().url(),
  categoryId: z.number().int().nullable(),
  spotsRemaining: z.number().int().nullable(),
  spotsTaken: z.number().int().nullable(),
  showRemaining: z.boolean(),
  remainingText: z.string().nullable(),
  verbiage: z.string().nullable(),
  dates: z
    .array(
      z.object({
        doorsAt: z.string().datetime().nullable(),
        startsAt: z.string().datetime(),
        endsAt: z.string().datetime()
      })
    )
    .nullable(),
  alternateTitle: z.string().nullable(),
  timeZoneId: z.string().nullable(),
  areaName: z.string().nullable(),
  areaKey: z.string().nullable(),
  paymentProfileId: z.string().nullable(),
  acctCode: z.string().nullable(),
  isHidden: z.boolean(),
  isFlexPass: z.boolean(),
  registered: z.boolean().default(false),
  bookmarked: z.boolean().default(false),
  description: z.string().nullable(),
  skillType: z.string().nullable(),
  causeType: z.string().nullable(),
  activityTypes: z
    .array(
      z.object({
        id: z.string(),
        name: z.string()
      })
    )
    .nullable()
    .optional(),

  skillTypes: z
    .array(
      z.object({
        id: z.string(),
        name: z.string()
      })
    )
    .nullable()
    .optional(),

  address: z.string().nullable(),
  city: z.string().nullable(),
  region: z.string().nullable(),
  website: z.string().url().nullable(),
  postalCode: z.string().nullable(),
  startsAt: z.string().datetime().nullable(),
  endsAt: z.string().datetime().nullable(),
  volunteerArrivalAt: z.string().datetime().nullable(),
  overallCapacity: z.number().int().nullable(),
  coordinatorFirstName: z.string().nullable(),
  coordinatorLastName: z.string().nullable(),
  locationType: z.string().nullable(),
  partneringOrganizationsCount: z.number().nullable(),
  partneringOrganizations: z.string().nullable(),
  typeOfOutreachProject: z.array(z.string()),
  internalVolunteersCount: z.number().nullable(),
  preferredSkills: z.array(z.string()),
  areMinorsAllowed: z.boolean().nullable(),
  isBilingual: z.boolean().nullable(),
  bilingual: z.string().nullable(),
  additionalInformation: z.string().nullable(),
  organization: z
    .object({
      name: z.string(),
      description: z.string(),
      heroImageUrl: z.string(),
      slug: z.string(),
      logoImageUrl: z.string()
    })
    .nullable(),
  sponsors: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        description: z.string().nullable().optional(),
        logoImageUrl: z.string().nullable().optional(),
        slug: z.string()
      })
    )
    .nullable()
    .optional()
});

export type EventNew = z.infer<typeof eventSchema>;
